import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { UserListDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { ProjectService } from '../../Services/project.service';
import { ApproverDetail } from '../models/ApproverDetail.model';
import { AppComponentBase } from '@shared/common/app-component-base';
@Component({
    standalone: false,
    selector: 'approver-template',
    templateUrl: './approver-template.component.html',
    styleUrls: ['./approver-template.component.scss']
})
export class ApproverTemplateComponent extends AppComponentBase implements OnInit {

    constructor(injector: Injector, private _userServiceProxy: UserServiceProxy, public _projService: ProjectService) {
        super(injector);
    }

    @Input() editApproverDetail: ApproverDetail;
    @Input() ProjectTeam: UserListDto[];
    @Input() levelValue: any;
    @Input() isRequired: boolean;
    @Output() approverDataSelection = new EventEmitter<ApproverDetail>();

    filterText = "";
    usersData: UserListDto[] = [];
    approverDetails: ApproverDetail = new ApproverDetail();

    WindowEnum = [
        { id: 1, name: this.l("Hours") },
        { id: 2, name: this.l("Days") }
    ]

    ngOnInit(): void {

        this.editApproverDetail;
    }
    ngOnChanges() {
        this.assignEdit(this.editApproverDetail)
    }
    ngDoCheck() {
    }

    assignEdit(editApproverDetail: ApproverDetail) {
        if (editApproverDetail != null) {
            this.approverDetails.user = editApproverDetail.user;
            this.approverDetails.WindowEnum = editApproverDetail.WindowEnum;
            this.approverDetails.WindowNum = editApproverDetail.WindowNum;
        }
    }

    getUsers() {
        this._userServiceProxy
            .getUsers(
                this.filterText,
                undefined,
                undefined,
                undefined,
                undefined,
                false,
                undefined,
                undefined,
                undefined,
                undefined
            )
            .pipe()
            .subscribe((result) => {
                this.usersData = result.items;
            });
    }

    emitdata() {
        if (!this.approverDetails.WindowNum) {
            this.approverDetails.WindowNum = undefined;
        }

        this.approverDataSelection.emit(this.approverDetails);
    }

    emitDelete() {

        this.approverDetails.user = null;
        this.approverDetails.WindowEnum = null;
        this.approverDetails.WindowNum = null;

        this.approverDataSelection.emit(this.approverDetails);
    }

    onlyNumberKey(event) {

    }

    disabledTooltip(name: string, num: number) {
        return name.length > num ? true : false;
    }
}
